export const SEND_MESSAGE = 'SEND_MESSAGE';
export const RECEIVE_SENT_MESSAGE = 'RECEIVE_SENT_MESSAGE';
export const RECEIVE_MESSAGE = 'RECEIVE_MESSAGE';
export const SHOW_TYPING = 'SHOW_TYPING';
export const CLEAR_TYPING = 'CLEAR_TYPING';
export const SEND_GEOLOCATION = 'SEND_GEOLOCATION';
export const SEND_USER_DATA = 'SEND_USER_DATA';
export const LOAD_PREVIOUS_ACTIVITIES = 'LOAD_PREVIOUS_ACTIVITIES';
export const LOAD_PREVIOUS_ACTIVITIES_SUCCESS = 'LOAD_PREVIOUS_ACTIVITIES_SUCCESS';
export const LOAD_PREVIOUS_ACTIVITIES_FAILED = 'LOAD_PREVIOUS_ACTIVITIES_FAILED';
export const SCROLLED_TO_REQUEST_PREVIOUS_ACTIVITIES = 'SCROLLED_TO_REQUEST_PREVIOUS_ACTIVITIES';
export const CLEAR_HISTORY = 'CLEAR_HISTORY';
export const RECEIVE_UNREAD_MESSAGE = 'RECEIVE_UNREAD_MESSAGE';
export const READ_UNREAD_MESSAGES = 'READ_UNREAD_MESSAGES';
export const RECORD_BUTTON_CLICKS = 'RECORD_BUTTON_CLICKS';
export const SEND_USER_ACTION = 'SEND_USER_ACTION';
export const SEND_USER_TYPING = 'SEND_USER_TYPING';

export const sendButtonClicksEvent = analyticsEventName => ({
  type: RECORD_BUTTON_CLICKS,
  activity: {
    name: 'cardButtonClicks',
    locale: 'en-GB',
    type: 'event',
    analyticsEventName,
    source: 'user'
  }
});

export const sendAttachment = (file, objectUrl) => ({
  type: SEND_MESSAGE,
  activity: {
    locale: 'en-GB',
    textFormat: 'plain',
    type: 'message',
    messageType: file.type,
    file,
    source: 'user',
    text: file.name,
    objectUrl
  }
});

export const sendFile = file => ({
  type: SEND_MESSAGE,
  activity: {
    locale: 'en-GB',
    textFormat: 'plain',
    type: 'message',
    file,
    source: 'user',
    text: file.name
  }
});

export const sendTextMessage = ({
  text,
  choiceNodeOriginText = undefined,
  skipTranslation = false
}) => ({
  type: SEND_MESSAGE,
  activity: {
    locale: 'en-GB',
    textFormat: 'plain',
    type: 'message',
    text,
    choiceNodeOriginText,
    source: 'user',
    skipTranslation
  }
});

export const sendPostback = ({ text, description }) => ({
  type: SEND_MESSAGE,
  activity: {
    type: 'message',
    locale: 'en-GB',
    text,
    description,
    displayField: 'description',
    source: 'user'
  }
});

export const sendGeolocation = () => ({
  type: SEND_GEOLOCATION
});

export const sendUserData = ({ data }) => ({
  type: SEND_USER_DATA,
  activity: {
    locale: 'en-GB',
    type: 'event',
    name: 'userData',
    data,
    source: 'user'
  }
});

export const sendUserAction = (userAction, id) => ({
  type: SEND_USER_ACTION,
  activity: {
    locale: 'en-GB',
    type: 'event',
    name: 'userAction',
    userAction,
    messageId: id,
    source: 'user'
  }
});

export const sendUserTyping = () => ({
  type: SEND_USER_TYPING,
  activity: {
    locale: 'en-GB',
    type: 'typing',
    source: 'user'
  }
});

export const receiveSentMessage = ({ activity }) => ({
  type: RECEIVE_SENT_MESSAGE,
  activity
});

export const receiveMessage = ({ activity }) => ({
  type: RECEIVE_MESSAGE,
  activity
});

export const receiveUnreadMessage = activityId => ({
  type: RECEIVE_UNREAD_MESSAGE,
  activityId
});

export const readUnreadMessages = () => ({
  type: READ_UNREAD_MESSAGES
});

export const receiveOperatorEvent = activity => ({
  type: RECEIVE_MESSAGE,
  activity
});

export const showTyping = ({ activity }) => ({
  type: SHOW_TYPING,
  activity
});

export const clearTyping = ({ activity }) => ({
  type: CLEAR_TYPING,
  activity
});

export const loadPreviousActivities = ({ domain, userId, skip, before }) => ({
  type: LOAD_PREVIOUS_ACTIVITIES,
  domain,
  userId,
  skip,
  before
});

export const loadPreviousActivitiesSuccess = ({ activities, paginationData }) => ({
  type: LOAD_PREVIOUS_ACTIVITIES_SUCCESS,
  activities,
  paginationData
});

export const loadPreviousActivitiesFailed = () => ({
  type: LOAD_PREVIOUS_ACTIVITIES_FAILED
});

export const scrolledToRequestPreviousActivities = () => ({
  type: SCROLLED_TO_REQUEST_PREVIOUS_ACTIVITIES
});

export const clearHistory = () => ({
  type: CLEAR_HISTORY
});



// WEBPACK FOOTER //
// ./src/reducers/history/actions.js